import { GetFilterDataResponseBody } from '../../types/generated/filterData_get.response';
import apiEndpoints from '../../../apiEndpoints';
import { fetcher } from '../../utils/fetchers/fetcher';

export const requestFilterData = (
  ids: string,
  token: string | null,
  forceHeader?: string
): Promise<GetFilterDataResponseBody> =>
  fetcher<GetFilterDataResponseBody>(
    `${apiEndpoints.routes.filterData}`,
    'GET',
    token,
    forceHeader,
    { filterIds: ids }
  );
